/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Club_Not_A_MemberInputs */

const en_us2_club_not_a_member = /** @type {(inputs: Club_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're not in this club.`)
};

const pt_br2_club_not_a_member = /** @type {(inputs: Club_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não está neste clube.`)
};

const es_419_club_not_a_member = /** @type {(inputs: Club_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No estás en este club.`)
};

const pt_pt2_club_not_a_member = /** @type {(inputs: Club_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não estás neste clube.`)
};

const fr_fr2_club_not_a_member = /** @type {(inputs: Club_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu n'es pas dans ce club.`)
};

const de_de2_club_not_a_member = /** @type {(inputs: Club_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bist nicht in diesem Club.`)
};

const it_it2_club_not_a_member = /** @type {(inputs: Club_Not_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non sei in questo club.`)
};

/**
* | output |
* | --- |
* | "You're not in this club." |
*
* @param {Club_Not_A_MemberInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const club_not_a_member = /** @type {((inputs?: Club_Not_A_MemberInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Club_Not_A_MemberInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_club_not_a_member(inputs)
	if (locale === "es-419") return es_419_club_not_a_member(inputs)
	if (locale === "pt-PT") return pt_pt2_club_not_a_member(inputs)
	if (locale === "fr-FR") return fr_fr2_club_not_a_member(inputs)
	if (locale === "de-DE") return de_de2_club_not_a_member(inputs)
	if (locale === "it-IT") return it_it2_club_not_a_member(inputs)
	return en_us2_club_not_a_member(inputs)
});
export { club_not_a_member as "club.not_a_member" }